import { createAction } from 'redux-actions';

import { SET_TOASTIFY } from '../types';

export const setToastifyAction = createAction(SET_TOASTIFY);
